import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import formats from '../../../../const/formats';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import getScriptByScriptName from '../../../../services/mini/getScriptByScriptName';

const FONT_MODE_STOTAGE_KEY = 'script-font-mode';
const FONT_MODE_DEFAULT = 'medium';

const CODE_THEME_STOTAGE_KEY = 'script-code-theme';
const CODE_THEME_DEFAULT = 'alan-default-theme';

class ScriptHeader extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            fontMode: isLocalStorageAvailable() ? (localStorage.getItem(FONT_MODE_STOTAGE_KEY) || FONT_MODE_DEFAULT) : FONT_MODE_DEFAULT,
            codeTheme: isLocalStorageAvailable() ? (localStorage.getItem(CODE_THEME_STOTAGE_KEY) || CODE_THEME_DEFAULT) : CODE_THEME_DEFAULT
        };
    }

    changeFont = (fontInfo) => {
        this.setState({ fontMode: fontInfo.id });
        if (isLocalStorageAvailable()) {
            localStorage.setItem(FONT_MODE_STOTAGE_KEY, fontInfo.id);
        }
    }

    changeCodeTheme = (codeThemeInfo) => {
        this.setState({ codeTheme: codeThemeInfo.id });
        if (isLocalStorageAvailable()) {
            localStorage.setItem(CODE_THEME_STOTAGE_KEY, codeThemeInfo.id);
        }
    }

    render() {
        const {
            name,
            updateTs,
            hasUnsavedChanges,
            toggleOnlyIntentsMode,
            showIntentsModeSwitcher,
            children,
            hasGutter
        } = this.props;

        const {
            fontMode,
            codeTheme
        } = this.state;

        return (<div className={`script-header font-${fontMode} ${codeTheme}`}>

            <div className="script-header_left">
                <div className={`script-header_script-name ${hasGutter && 'has-gutter'}`} title={name}>
                    {name}
                </div>
                {children && children}
                <div className="script-header_update-ts">
                    {updateTs ? moment(updateTs).format(formats.MMM_DD_hh_mm_a) : ''}
                </div>
            </div>

            <div className="script-header_right">
                {showIntentsModeSwitcher &&
                    <div className={`script-header_show-intents-btn ${hasUnsavedChanges && 'disabled'}`} onClick={toggleOnlyIntentsMode}>
                        <i className={`icon icon-alan-intent-${showIntentsModeSwitcher ? 'hide-' : ''}sign`}></i>
                        {showIntentsModeSwitcher ? 'Show all code' : 'Show only intents'}
                    </div>}
            </div>
        </div>
        );
    }
}


ScriptHeader.propTypes = {
    name: PropTypes.string.isRequired,
    hasUnsavedChanges: PropTypes.bool,
    showIntentsModeSwitcher: PropTypes.bool,
    toggleOnlyIntentsMode: PropTypes.func,
};


function mapStateToProps({ projectsInfo }, ownProps) {
    const { name } = ownProps;
    const script = getScriptByScriptName(name, projectsInfo.currentProject);

    return {
        updateTs: script ? +script.updateTs : null
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ScriptHeader);